import { PropsWithChildren } from 'react'

interface DefaultObjectContainerProps {
  title?: string
  nested?: boolean
}

export const DefaultObjectContainer = ({
  title,
  nested,
  children,
}: PropsWithChildren<DefaultObjectContainerProps>) => {
  return (
    <div className={`d-flex flex-column ${nested ? 'ml-4' : ''}`} style={{ gap: '1rem' }}>
      {title && <p className="mb-0">{title}</p>}

      {children}
    </div>
  )
}
